




















































import mixins from 'vue-typed-mixins'
import Reviews from '@/calendesk/sections/section/reviews/mixins/Reviews'
import DefaultButton from '@/calendesk/sections/section/components/DefaultButton.vue'

export default mixins(Reviews).extend({
  name: 'FlexibleReviews2',
  components: { DefaultButton },
  data () {
    return {
    }
  }
})
